import { render, staticRenderFns } from "./rsvSendMessage.vue?vue&type=template&id=02f67aee"
import script from "./rsvSendMessage.vue?vue&type=script&lang=js"
export * from "./rsvSendMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports